/* @flow */

// The endpoint needs 2 characters for a field in order to search
export const MIN_SEARCH_LENGTH = 2;
export const ROWS = 14;
